import React from "react";
import { ShieldCheck } from "lucide-react";

/**
 * Бейдж "Проверенный исполнитель" (Аудит #35).
 * Светло-зелёный, с переливающейся (shimmer) анимацией.
 *
 * Props:
 *  - size: "xs" | "sm" | "md" — размер
 *  - showLabel: bool — показывать текст рядом с иконкой (по умолчанию true для md, false для xs/sm)
 *  - title: tooltip (по умолчанию "Проверенный исполнитель")
 */
export const VerifiedExecutorBadge = ({ size = "sm", showLabel, title = "Проверенный исполнитель", className = "" }) => {
  const sizePresets = {
    xs: { wrap: "px-1.5 py-0.5 text-[10px] gap-0.5", icon: 10 },
    sm: { wrap: "px-2 py-0.5 text-[11px] gap-1", icon: 12 },
    md: { wrap: "px-2.5 py-1 text-xs gap-1.5", icon: 14 },
  };
  const cfg = sizePresets[size] || sizePresets.sm;
  const labelVisible = showLabel ?? (size === "md" || size === "sm");

  return (
    <span
      title={title}
      data-testid="verified-executor-badge"
      className={`reversia-verified-badge inline-flex items-center font-semibold rounded-full leading-none ${cfg.wrap} ${className}`}
    >
      <ShieldCheck size={cfg.icon} className="reversia-verified-badge__icon" />
      {labelVisible && <span className="reversia-verified-badge__text">Проверенный</span>}
    </span>
  );
};

export default VerifiedExecutorBadge;
